import { updateRef2 } from '@back-office/http';
import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { REF2_EDITED_MAX_LENGTH } from '../../../constants';
import useInject from '../../../hooks/useInject';

type UseViewModelProps = {
  txId: string;
  ref2: string;
  refresh: () => void;
  onUpdated: () => void;
};

type UseViewModelReturn = {
  handleOnChange: (val: ChangeEvent<HTMLInputElement>) => void;
  handleSave: () => void;
  enableSaveEdited: boolean;
  handleOnClickEdit: () => void;
  showEditRef2: Map<string | null, boolean>;
  isStaticQrTransaction: (type: string | null) => boolean;
  editedRef2: string;
};

const useViewModel = ({
  txId,
  ref2,
  refresh,
  onUpdated,
}: UseViewModelProps): UseViewModelReturn => {
  const { alert, auth } = useInject((store) => store);
  const isStaticQrTransaction = (type: string | null): boolean =>
    type === 'StaticQR';
  const [showEditRef2, setShowEditRef2] = useState<Map<string | null, boolean>>(
    new Map()
  );
  const [editedRef2, setEditedRef2] = useState<string>(ref2);
  const { t } = useTranslation();
  const [enableSaveEdited, setEnableSaveEdited] = useState<boolean>(true);
  const handleOnClickEdit = (): void => {
    setEditedRef2(ref2);
    setShowEditRef2(new Map([[ref2, true]]));
  };

  const handleSave = (): void => {
    alert.openAlert({
      cancelBtn: 'dialog.cancel',
      okBtn: 'dialog.confirm',
      title: t('transaction_list.edit_confirmation'),
      message: t('transaction_list.edit_confirmation_content'),
      handleCancel() {
        alert.closeDialog();
        setEditedRef2(ref2 || '-');
        setShowEditRef2(new Map());
        setEnableSaveEdited(false);
      },
      async handleOK() {
        updateRef2(txId, editedRef2 || '-', auth.currentUser.merchantID)
          .then(() => {
            onUpdated();
            setShowEditRef2(new Map());
            refresh();
          })
          .finally(() => alert.closeDialog());
      },
    });
  };
  const handleOnChange = (val: ChangeEvent<HTMLInputElement>): void => {
    setEnableSaveEdited(
      val.target.value.length <= REF2_EDITED_MAX_LENGTH &&
        val.target.value.length !== 0
    );
    setEditedRef2(val.target.value);
  };

  return {
    handleOnChange,
    handleSave,
    enableSaveEdited,
    handleOnClickEdit,
    showEditRef2,
    isStaticQrTransaction,
    editedRef2,
  };
};

export default useViewModel;
